import React from 'react';
import classNames from 'classnames/bind';
import Rating from '../../atoms/Rating';
import styles from './index.pcss';
import FallbackableImage from '../../molecules/FallbackableImage';

interface FallbackableImageProps {
  brandName: string;
  description: string;
  imageUrl: string;
  productRating: number;
  variant: 'desktop' | 'mobile';
  feedbackCard: boolean;
  productCode?: string;
  onRatingClickHandler: (rating: number) => void;
  displayError?: boolean;
  enableReview?: boolean;
  showReviewProdBtn?: boolean;
}
const cx = classNames.bind(styles);
const RatingProductCard = ({
  brandName = '',
  description = '',
  imageUrl = '',
  productRating = 0,
  variant = 'mobile',
  feedbackCard = false,
  displayError = false,
  onRatingClickHandler,
  enableReview = false,
  showReviewProdBtn = false
}: FallbackableImageProps) => {
  const isDesktop = variant === 'desktop';
  let labelCta = '';

  if (enableReview && showReviewProdBtn) {
    labelCta = 'Write a Review';
  } else {
    labelCta = 'Rate this Product';
  }

  return (
    <div className={cx(`product-card-container-${isDesktop ? 'desktop' : 'mobile'}`)}>
      <div className={cx('rating-product-card-image')}>
        <FallbackableImage
          src={imageUrl}
          id="image"
          key="full-image-view"
          alt="Image Details"
          htmlLoading="eager"
          imageCls={cx('image')}
          customErroredImgCls={cx('img-load-errored')}
        />
      </div>
      <div className={cx('product-card-details')}>
        <p className={cx('brand-name')} role='heading' aria-level={2}>{brandName}</p>
        <p className={cx('description')}>{description}</p>
        {feedbackCard ? (
          <>
            <div
              className={cx('feedback-rating-container', {
                'rating-failed-container': displayError
              })}
            >
              <p className={cx('feedback-rating-text')}>{labelCta}</p>
              <div className={cx('feedback-rating')}>
                <Rating
                  iconSize="md"
                  rating={productRating}
                  onClickHandler={onRatingClickHandler}
                />
              </div>
            </div>
            {displayError && (
              <p className={cx('rating-failure')}>
                Your rating couldn't be submitted due to technical issues. Try again.
              </p>
            )}
          </>
        ) : (
          <div className={cx('rating-container')}>
            <Rating
              iconSize={isDesktop ? 'sm' : 'lg'}
              rating={productRating}
              onClickHandler={onRatingClickHandler}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RatingProductCard;
